module.exports = __webpack_public_path__ + "img/error-state.29f154b7.svg";